export enum DisplayLogicPropertyUnderValidation {
	DisplayLogicAction = 'DisplayLogicAction',
	DisplayLogicCondition = 'DisplayLogicCondition',
	DisplayLogicValue = 'DisplayLogicValue',
}
